import React from 'react'
import { ResponsiveSVG } from 'ui/acro'
import { Dashboard } from 'images/latest'

const DashboardIcon = () => (
  <ResponsiveSVG
    width={['56px', null, '56px']}
    className='unstyled'
    svgProps={{ viewBox: '0 0 56 56' }}
    SVG={Dashboard}
  />
)

export default DashboardIcon
